import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const FindAHomeLocationIndicatorStyles = styled.button`
  background-color: #fff;
  border: none;
  cursor: pointer;

  .bottom-controls {
    margin-top: 10px;
  }

  .location-button-desktop:hover,
  .location-button-mobile:hover {
    cursor: pointer;
  }
  > div {
    display: flex;
    justify-content: space-between;
  }
  .location-selector-container {
    position: relative;
  }
  .location-button-desktop {
    display: none;
  }
  .zipError {
    width: 100px;
    border-bottom: 1px solid rgb(0, 117, 201);
  }
  @media only screen and (min-width: ${desktop_breakpoint}px) {
    .location-button-desktop {
      display: flex;
      margin-left: 20px;
    }
    .location-button-mobile {
      display: none;
    }
  }
`;
